export const MAX_EMBED_WIDTH = 1920
export const MIN_EMBED_WIDTH = 620

export const MAX_EMBED_HEIGHT = 1080
export const MIN_EMBED_HEIGHT = 385
